export default "__VITE_ASSET__DPIG27I$__"